import { AddressColors } from './models/addresses/address-color-enum'
import { AccelerationEventTypes } from './models/vehicle/acceleration-event-types-enum'
import { AccelerationVehicleTypes } from './models/vehicle/acceleration-vehicle-types-enum'
import { AccountDealerAccessLevel } from './models/settings/account-dealer-access-levels-enum'
import { ActivityTypes } from './models/activityTypes/activity-types-enum'
import { Area } from './models/areas/area-enum'
import { AreaSpeedLimitVehicleTypes } from './models/areas/area-speed-limit-vehicle-types-enum'
import { AreaSpeedProfiles } from './models/areas/area-speed-profiles-enum'
import { AxleLoadEvent } from './models/ebs/axle-load-event-enum'
import { CameraStatus } from './models/cameras/camera-status'
import { CameraViewsTypes } from './models/cameras/camera-views-types'
import { CameraModels } from './models/cameras/camera-models'
import { CameraOperationModes } from './models/cameras/camera-operation-modes'
import { CameraSpeedUnits } from './models/cameras/camera-speed-units'
import {
    CameraEventAvailability,
    CameraEventVideoAvailability,
    CameraEventType
} from './models/camera-events/camera-events'
import { CameraEventUserAccessActions } from './models/camera-events/camera-events-user-access-actions'
import { ChargingStationConnectorTypes } from './models/electric/charging-station-connector-types-enum'
import { ChecklistItemCategory } from './models/checklists/checklist-item-category-enum'
import { ColdChainApiConnectionExecutionResultEnum } from './models/cold-chain/cold-chain-api-connection-execution-result-enum'
import { ColdChainApiProvider } from './models/cold-chain/cold-chain-api-provider-enum'
import { ConfigSetAssignmentState } from './models/cold-chain/config-set-assignment-state-enum'
import { ControlFlags } from './models/common/control-flags-enum'
import { CoordinateFormats } from './models/settings/coordinate-formats'
import { CrashTypes } from './models/crash-event/crash-types-enum'
import { CurrentUserStates } from './models/current-user/current-user-states-enum'
import { CustomCouplingRuleModel } from './models/vehicle/custom-coupling-rule-model'
import { CustomCouplingRuleTypeEnum } from './models/vehicle/custom-coupling-rule-type-enum'
import { DealerSalesChannels } from './models/selfservice/dealer-sales-channels-enum'
import { DeviceTypes } from './models/drivers/device-types-enum'
import { DriverKeyTypes } from './models/drivers/driver-key-types-enum'
import { DriverRoles } from './models/drivers/driver-roles-enum'
import { DriverSources } from './models/drivers/driver-sources-enum'
import { ElectricVehicleProfileScopeTypes } from './models/electric/electric-vehicle-profile-scope-enum.js'
import { ElectricVehicleState } from './models/electric/electric-vehicle-state-enum'
import { ElectrifiableVehicleStates } from './models/electric/electrifiable-vehicle-states-enum'
import { EnergyConsumptionPreferences } from './models/vehicle/energy-consumption-preferences-enum'
import { EventLevels } from './models/notifications/event-levels-enum'
import { EvFuelTypes } from './models/electric/fuel-types-enum.js'
import { FuelLevelEventTypes } from './models/vehicle/fuel-level-event-types-enum'
import { FuelTypes } from './models/vehicle/fuel-types-enum'
import { InboxMessage } from './models/inbox-message/inbox-message-enum'
import { InboxMessageAttribute } from './models/inbox-message/inbox-message-attribute-enum'
import { IncidentClientDisplayOption } from './models/public-incidents/incident-client-display-option.js'
import { IncidentImpact } from './models/public-incidents/incident-impact.js'
import { IncidentStatus } from './models/public-incidents/incident-status.js'
import { LocationDescription } from './models/common/location-description'
import { LogBookModes } from './models/logbook/log-book-modes-enum'
import { ObjectAvailabilityStatus } from './models/vehicle/object-availability-status-enum'
import { ObjectClasses } from './models/vehicle/object-classes-enum'
import { ObjectColors } from './models/vehicle/object-colors-enum'
import { ObjectControlFlags } from './models/vehicle/object-control-flags-enum'
import { ObjectDriverAssignmentTypes } from './models/drivers/object-driver-assignment-types-enum'
import { ObjectEbsSettings } from './models/ebs/object-ebs-settings-enum'
import { ObjectEbsState } from './models/ebs/object-ebs-state-enum'
import { ObjectFuelUsages } from './models/vehicle/object-fuel-usages-enum'
import { ObjectImmobilizer } from './models/vehicle/object-immobilizer-model'
import { ObjectImmobilizerStateTypes, ObjectImmobilizerUpdateTypes } from './models/vehicle/object-immobilizer-enum'
import { ObjectGroupControlFlags } from './models/vehicle/object-group-control-flags-enum'
import { ObjectGroupModel } from './models/vehicle/object-group-model'
import { ObjectGroupTypes } from './models/vehicle/object-group-types-enum'
import { ObjectMessageCategory } from './models/message/object-message-category-enum'
import { ObjectMessageDirection } from './models/message/object-message-direction-enum'
import { ObjectTextMessageDirections } from './models/vehicle/object-text-message-directions-enum'
import { ObjectTypes } from './models/vehicle/object-types-enum'
import { OptiDriveComponentKpiDetails } from './models/drivers/opti-drive-component-kpi-details-enum'
import { OptiDriveComponentKpis } from './models/drivers/opti-drive-component-kpis-enum'
import { OptiDriveKpis } from './models/drivers/opti-drive-kpis-enum'
import { OptiDriveEventExclusionReasonType } from './models/opti-drive/opti-drive-event-exclusion-reason-type'
import { OptiDriveEventState } from './models/opti-drive/opti-drive-event-state'
import { OptiDriveEventExclusionModel } from './models/opti-drive/opti-drive-event-exclusion-model'
import { OptiDriveEventType } from './models/opti-drive/opti-drive-event-type.js'
import { OrderDocumentDefaultMaxFileSize } from './models/orders/order-document-supported-files'
import { OrderArrivalTolerances } from './models/orders/order-arrival-tolerances-enum.js'
import { OrderStates, OrderStatesSubsets } from './models/orders/order-states-enum.js'
import { OrderTypes } from './models/orders/order-types-enum.js'
import { OriginTypes as TrackOriginTypes } from './models/track/origin-types'
import { PasswordStatus } from './models/users/password-status-enum'
import { PressureUnits } from './models/settings/pressure-units'
import { RdtChangeMode } from './models/rdt/rdt-change-mode-enum'
import { RdtInfringementLevels } from './models/rdt/rdt-infringement-levels-enum'
import { RdtInfringementTypes } from './models/rdt/rdt-infringement-types-enum'
import { RdtRegulationTypes } from './models/rdt/rdt-regulation-types-enum'
import { RdtRuleTypes } from './models/rdt/rdt-rule-types-enum'
import { RdtTimesWarningLevels } from './models/rdt/rdt-times-warning-levels-enum'
import { RdtWeeklyWorkingAverageType } from './models/rdt/rdt-weekly-working-average-type'
import { RoadTypes } from './models/common/road-types-enum'
import { SevenDayRulesStatus } from './models/logbook/seven-day-rules-status-enum'
import { SupportedThirdPartyServices } from './models/common/supported-third-party-services'
import { StealthModes } from './models/vehicle/stealth-modes-enum'
import { TachographTypes } from './models/vehicle/tachograph-types-enum'
import { TelematicDeviceAccessoryTypes } from './models/vehicle/telematic-device-accessory-type-enum'
import { TemperatureUnits } from './models/settings/units'
import { TemperatureSensorTypes } from './models/cold-chain/temperature-sensor-types-enum'
import { TextMessageCommunicatorType } from './models/message/text-message-communicator-type-enum'
import { TextMessageStatus } from './models/message/text-message-status-enum'
import { TextMessageType } from './models/message/text-message-type-enum'
import { TextMessage } from './models/message/text-message-enum'
import { TireInspectionActivityType } from './models/tpms/tpms-tire-inspections-enum'
import { TpmsAxleTypes } from './models/tpms/tpms-axle-types-enum'
import { TpmsBatteryLevels } from './models/tpms/tpms-battery-levels-enum'
import { TpmsIssueSeverity } from './models/tpms/tpms-issue-severity-enum'
import { TpmsIssueSeverityNames } from './models/tpms/tpms-issue-severity-names-enum'
import { TpmsIssueTypes } from './models/tpms/tpms-issue-types-enum'
import { TpmsObjectClasses } from './models/tpms/tpms-object-classes-enum'
import { TpmsReceiverTypes } from './models/tpms/tpms-receiver-types-enum'
import { TpmsSensorReceiverTypes } from './models/tpms/tpms-sensor-receiver-types-enum'
import { TpmsSensorTypes } from './models/tpms/tpms-sensor-types-enum'
import { TpmsStatisticsAggregationLevel } from './models/tpms/tpms-statistics-aggregation-level-enum'
import { TpmsStatisticsGranularity } from './models/tpms/tpms-statistics-granularity-enum'
import { TpmsStatisticsEntity } from './models/tpms/tpms-statistics-entity-enum'
import { TpmsStatisticsLpi } from './models/tpms/tpms-statistics-lpi-enum'
import { TpmsStatisticsSortOrder } from './models/tpms/tpms-statistics-sort-order-enum'
import { TpmsTireAttachmentStatus } from './models/tpms/tpms-tire-attachment-status-enum'
import { TpmsTireLocations } from './models/tpms/tpms-tire-locations-enum'
import { TpmsTirePatterns } from './models/tpms/tpms-tire-patterns-enum'
import { Track } from './models/track/track-enum'
import { Trip } from './models/trip/trip-enum'
import { TripModes } from './models/trip/trip-modes-enum'
import { UserStates } from './models/users/user-states-enum'
import { LinkDeviceType } from './models/vehicle/link-device-type-enum'
import { VehicleObjectDetailsModel } from './models/vehicle/vehicle-object-details-model'
import { VehicleObjectModel } from './models/vehicle/vehicle-object-model'
import { VehicleUsageType } from './models/vehicle/vehicle-usage-type-enum'
import { WorkStateDevices } from './models/drivers/work-state-devices-enum'
import { WorkStates } from './models/drivers/work-states-enum'
import { AccountTypes } from './models/current-user/account-types-enum.js'
import { EbpmsSummaryStatus } from './models/ebs/ebpms-summary-status-enum.js'
import { BrakePerformance } from './models/ebs/brake-performance-enum.js'

/**
 * @type {Object}
 */
export const RestModels = {
    AccelerationEventTypes,
    AccelerationVehicleTypes,
    AccountDealerAccessLevel,
    AccountTypes,
    ActivityTypes,
    AddressColors,
    Area,
    AreaSpeedLimitVehicleTypes,
    AreaSpeedProfiles,
    AxleLoadEvent,
    BrakePerformance,
    CameraEventAvailability,
    CameraEventType,
    CameraEventUserAccessActions,
    CameraEventVideoAvailability,
    CameraModels,
    CameraOperationModes,
    CameraSpeedUnits,
    CameraStatus,
    CameraViewsTypes,
    ChargingStationConnectorTypes,
    ChecklistItemCategory,
    ColdChainApiConnectionExecutionResultEnum,
    ColdChainApiProvider,
    ConfigSetAssignmentState,
    ControlFlags,
    CoordinateFormats,
    CrashTypes,
    CurrentUserStates,
    CustomCouplingRuleModel,
    CustomCouplingRuleTypeEnum,
    DealerSalesChannels,
    DeviceTypes,
    DriverKeyTypes,
    DriverRoles,
    DriverSources,
    EbpmsSummaryStatus,
    ElectricVehicleProfileScopeTypes,
    ElectricVehicleState,
    ElectrifiableVehicleStates,
    EnergyConsumptionPreferences,
    EventLevels,
    EvFuelTypes,
    FuelLevelEventTypes,
    FuelTypes,
    InboxMessage,
    InboxMessageAttribute,
    IncidentClientDisplayOption,
    IncidentImpact,
    IncidentStatus,
    LinkDeviceType,
    LocationDescription,
    LogBookModes,
    ObjectAvailabilityStatus,
    ObjectClasses,
    ObjectColors,
    ObjectControlFlags,
    ObjectDriverAssignmentTypes,
    ObjectEbsSettings,
    ObjectEbsState,
    ObjectFuelUsages,
    ObjectGroupControlFlags,
    ObjectGroupModel,
    ObjectGroupTypes,
    ObjectImmobilizer,
    ObjectImmobilizerStateTypes,
    ObjectImmobilizerUpdateTypes,
    ObjectMessageCategory,
    ObjectMessageDirection,
    ObjectTextMessageDirections,
    ObjectTypes,
    OptiDriveComponentKpiDetails,
    OptiDriveComponentKpis,
    OptiDriveEventExclusionModel,
    OptiDriveEventExclusionReasonType,
    OptiDriveEventState,
    OptiDriveEventType,
    OptiDriveKpis,
    OrderArrivalTolerances,
    OrderDocumentDefaultMaxFileSize,
    OrderStates,
    OrderStatesSubsets,
    OrderTypes,
    PasswordStatus,
    PressureUnits,
    RdtChangeMode,
    RdtInfringementLevels,
    RdtInfringementTypes,
    RdtRegulationTypes,
    RdtRuleTypes,
    RdtTimesWarningLevels,
    RdtWeeklyWorkingAverageType,
    RoadTypes,
    SevenDayRulesStatus,
    StealthModes,
    SupportedThirdPartyServices,
    TachographTypes,
    TelematicDeviceAccessoryTypes,
    TemperatureSensorTypes,
    TemperatureUnits,
    TextMessage,
    TextMessageCommunicatorType,
    TextMessageStatus,
    TextMessageType,
    TireInspectionActivityType,
    TpmsAxleTypes,
    TpmsBatteryLevels,
    TpmsIssueSeverity,
    TpmsIssueSeverityNames,
    TpmsIssueTypes,
    TpmsObjectClasses,
    TpmsReceiverTypes,
    TpmsSensorReceiverTypes,
    TpmsSensorTypes,
    TpmsStatisticsAggregationLevel,
    TpmsStatisticsEntity,
    TpmsStatisticsGranularity,
    TpmsStatisticsLpi,
    TpmsStatisticsSortOrder,
    TpmsTireAttachmentStatus,
    TpmsTireLocations,
    TpmsTirePatterns,
    Track,
    TrackOriginTypes,
    Trip,
    TripModes,
    UserStates,
    VehicleObjectDetailsModel,
    VehicleObjectModel,
    VehicleUsageType,
    WorkStateDevices,
    WorkStates
}
